<template>
  <div class="activity" name="活动错位轮播" v-if="list.length">
    <swiper id="activityBanner" :options="activitySwiper" ref="activitySwiperRef" style="height: 100%">
      <swiper-slide ref="activityItem" v-for="(item, index) of list" :key="index">
        <img
          class="main-img radius-8px"
          :src="item.img_path"
          @error="
            (event) => {
              let img = event.srcElement
              img.src = errorImg
              img.onerror = null
            }
          "
        />
        <div
          :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=5'"
          :username="'gh_5d4bb8e18b8b'"
          class="slide_cl_xcx"
          v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
        ></div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination" id="activitySwiperPagination"></div>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { checkAgent, isWeixin } from '../../../assets/common/js/config'
import adExposeMixin from '../js/adExposeMixin'

export default {
  name: 'activityStaggerSwiper',
  mixins: [adExposeMixin],
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    /** 埋点 flowArea 前缀，如 bannerZone */
    flow_area_prefix: {
      type: String,
      default: 'act'
    },
  },
  data() {
    var that = this
    return {
      isWx: isWeixin() ? 1 : 0,
      activitySwiper: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        slidesPerView: 2.28,
        slidesPerGroup: 1,
        on: {
          click: function () {
            var next,
              prev,
              activeIndex = this.realIndex
            if (this.clickedSlide.className.indexOf('swiper-slide-next') >= 0) {
              if (activeIndex == that.list.length - 1) {
                activeIndex = 0
              } else {
                activeIndex = activeIndex + 1
              }
            } else if (this.clickedSlide.className.indexOf('swiper-slide-prev') >= 0) {
              if (activeIndex == 0) {
                activeIndex = that.list.length - 1
              } else {
                activeIndex = activeIndex - 1
              }
            }
            if (checkAgent() != 'Harmony') {
              that.bannerClickHandle(
                that.list[activeIndex],
                activeIndex,
                that.flow_area_prefix + '-' + (activeIndex + 1)
              )
            }
          }
        },
        pagination: {
          el: '#activitySwiperPagination',
          type: 'bullets'
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.bindHarmonySwiper()
      var that = this
      setTimeout(function () {
        that.bindAdExposeSlidesHandle()
      }, 50)
    })
  },
  watch: {
    list: function () {
      this.scheduleAdExposeBindHandle(this.bindAdExposeSlidesHandle)
    }
  },
  methods: {
    bindAdExposeSlidesHandle: function () {
      var that = this
      if (!this.$el || !this.list || !this.list.length) return
      var slides = this.$el.querySelectorAll('.swiper-slide')
      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i]
        var id = slide.getAttribute('data-swiper-slide-index')
        if (id == null) id = String(i)
        id = parseInt(id, 10)
        if (isNaN(id) || !that.list[id]) continue
        that.bindAdExposeHandle(slide, that.flow_area_prefix + '-' + (id + 1), that.list[id])
      }
    },
    bannerClickHandle(items, index, flowArea) {
      this.$emit('banner-click', items, index, flowArea)
    },
    bindHarmonySwiper() {
      if (!this.list.length || !this.$refs.activitySwiperRef) return
      const swiperEl = this.$refs.activitySwiperRef.$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          let slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            this.bannerClickHandle(this.list[id], id, this.flow_area_prefix + '-' + (id + 1))
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.activity {
  margin: 0.1rem 0 0;
  padding-bottom: 0.1rem;
  position: relative;
  #activitySwiperPagination {
    width: 100%;
    bottom: 0;
  }
}
</style>

<style lang="scss">
.index {
  .activity {
    width: 100%;
    overflow: hidden;
    .swiper-container {
      width: 128%;
      margin-left: -14%;
    }

    .swiper-slide .main-img {
      width: 100%;
      height: 2.7rem;
      margin: 0 auto;
      display: block;
      transition: all 0.3s;
    }
    .swiper-slide {
      transform: scale(0.9);
      transition: all 0.2s ease-in 0s;
      border-top-left-radius: 0.07rem;
      border-top-right-radius: 0.07rem;
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
      border-top-left-radius: 0.04rem;
      border-top-right-radius: 0.04rem;
    }
  }
  #activitySwiperPagination {
    width: auto;
    font-size: 0;
    color: #ffffff;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }
  #activitySwiperPagination {
    text-align: center;
    span {
      margin-left: 0.05rem;
      background: rgba(0, 0, 0, 0.2);
      &.swiper-pagination-bullet {
        width: 0.11rem;
        height: 0.02rem;
        border-radius: 0.01rem;
        margin: 0 !important;
        background: #cccccc;
      }
      &:first-child {
        margin-left: 0;
      }
      &.swiper-pagination-bullet-active {
        background: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/activityStaggerSwiper.vue